import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TaskPreview from "../TaskPreview";
import { Droppable } from "react-beautiful-dnd";
import DraggableContainer from "./DraggableContainer";
import {
  ADD_NEW_SCHEDULED,
  FINISH_SCHEDULED,
} from "../../Constants/reducerEvents";
import { v4 as uuidv4 } from "uuid";
import ScheduledTask from "./ScheduledTask";
import { ta } from "date-fns/locale";
import TaskPreviewDot from "../TaskPreviewDot";

export default function TaskContainer({
  tasks = [],
  id,
  // showDate = true,
  // onClick,
  // oneLine = false,
  canCreate = false,
  label,
  labelColor,
}) {
  const timeslots = useSelector((state) =>
    state.scheduler[id] ? state.scheduler[id] : []
  );
  const dispatch = useDispatch();
  const inputRef = useRef();
  const [input, setInput] = useState("");
  const [showInput, setShowInput] = useState(false);
  const clickTask = (task) => {
    dispatch({
      type: ADD_NEW_SCHEDULED,
      payload: {
        key: id,
        item: { name: task.name, id: uuidv4(), taskId: task.id },
      },
    });
  };
  const addNewTimeslot = () => {
    if (!canCreate) {
      return;
    }
    setShowInput(true);
    if (
      inputRef.current &&
      typeof inputRef.current.getInputDOMNode === "function"
    ) {
      inputRef.current.getInputDOMNode().focus();
    }
  };
  const submitNewTimeslot = () => {
    if (input.length > 0) {
      console.log("submit", input, id);
      dispatch({
        type: ADD_NEW_SCHEDULED,
        payload: { key: id, item: { name: input, id: uuidv4(), taskId: null } },
      });
    }
    closeNewTimeslot();
  };
  const finishTimeslot = (index) => {
    dispatch({ type: FINISH_SCHEDULED, payload: { key: id, index: index } });
  };
  const closeNewTimeslot = () => {
    setInput("");
    setShowInput(false);
  };

  return (
    <div
      style={{
        flexGrow: 1,
        // overflow: "auto",
        width: "100%",
        display: "flex",
        flexFlow: "column",
      }}
      onClick={addNewTimeslot}
    >
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ color: labelColor }}>{label}</div>
        {tasks.map((t) => (
          <TaskPreviewDot key={t.id} task={t} onClick={() => clickTask(t)} />
        ))}
      </div>
      {/* {tasks.length > 0 && (
        <div
          style={{
            borderBottom:
              timeslots.length > 0 ? `1.5px solid ${labelColor}` : "none",
            paddingBottom: "4px",
            marginBottom: "5px",
          }}
        >
          {tasks.map((t) => (
            // <TaskPreviewDot key={t.id} task={t} onClick={() => clickTask(t)} />
            <TaskPreview
              task={t}
              showDate={false}
              oneLine
              onClick={() => clickTask(t)}
            />
          ))}
        </div>
      )} */}
      <Droppable droppableId={id}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{ flexGrow: 1 }}
          >
            {timeslots.map((t, i) => (
              <DraggableContainer key={t.id} id={t.id} index={i}>
                <ScheduledTask task={t} setComplete={() => finishTimeslot(i)} />
              </DraggableContainer>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {showInput && (
        <input
          ref={inputRef}
          type="text"
          autoFocus
          value={input}
          onKeyPress={(e) => {
            if (e.code === "Enter") {
              submitNewTimeslot();
            }
          }}
          onBlur={() => closeNewTimeslot()}
          onChange={(e) => setInput(e.target.value)}
          style={{ width: "90%" }}
        />
      )}
    </div>
  );
}
